import { CustomElement } from '@aurelia/runtime-html';
export const name = "data-pager";
export const template = "<template>\r\n    <div id=\"pagination-container\"></div>\r\n</template>\r\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
